<template>
  <b-card title="Skip Scan List ">
    <b-modal
      id="promptDownload"
      ref="modal"
      v-model="promptDownload"
      title="Download"
      hide-footer
    >
      <strong v-if="downloadLoading">Loading Data...</strong>
      <strong v-else>Loading data finished, total data is {{ inventoryToDownload.length }}</strong>
      <div>
        <strong> Progress {{ progressDownload }} %</strong>
      </div>
      <div style="display: table; margin: 0 auto;">
        <b-button :disabled="inventoryToDownload.length < totalRowsDownload" variant="primary" style="margin-top: 20px">
          <download-excel :data="inventoryToDownload" :fields="filter" :name="'skip-scan-report-'+new Date().getTime()+'.xls'" class="download-border">Download</download-excel>
        </b-button>
      </div>
    </b-modal>
    <b-col cols="12">
      <b-row>
        <b-col cols="5">
          Start Date (Scan Date)
          <b-form-datepicker @input="(value) => fireFiltering('startDate', value)" :max="endDate" :min="minmin" v-model="startDate" />
        </b-col>
        <b-col cols="5">
          End Date (Scan Date)
          <b-form-datepicker @input="(value) => fireFiltering('endDate', value)" :max="maxDate" v-model="endDate" />
        </b-col>
        <b-col cols="2">
          <b-button variant="primary" style="margin-top: 20px" @click="openDownloadModal">
            Download
          </b-button>
        </b-col>
      </b-row>
      <br>
      <!-- <b-row class="mt-1">
        <b-col cols="12">
          <v-select 
            :options="listStatus" 
            v-model="selectedStatus" 
            @input="(value) => statusFiltering(value)"
            placeholder="Select Status"
            multiple 
          ></v-select>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col style="margin: 15px 0 0 0" cols="12">
          <b-table
            :items="skipScan"
            :fields="fields"
            :busy.sync="busyLoading"
            responsive
            show-empty
            empty-text="Data Not Found"
          >
          <template v-slot:cell(scanTime)="row">
            {{ dates(row.item.scanTime) }}
          </template>
          <template v-slot:cell(scanUser)="row">
            {{ (row.item.scanUser==undefined)?"Unknown":row.item.scanUser.name }}
          </template>
            

          </b-table>
        </b-col>
        <b-col cols="12">
          <b-pagination :total-rows="totalRows" :per-page="perPage" @change="onPageChange" v-model="currentPage" style="float: right" />
        </b-col>
      </b-row>
    </b-col>
  </b-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import * as XLSX from 'xlsx'
import lodash from 'lodash';
import { userAccess, dateFormat,convertPDFtoBase64 } from "@/utils/utils";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      fields: [
        { key: 'sapDo', label: 'SAP DO', filterable: true, sortable: true },
        { key: 'status', label: 'Status', filterable: true, sortable: true },
        { key: 'itemModel', label: 'Item Model', filterable: true, sortable: true },
        { key: 'scanTime', label: 'Scan Time', filterable: true, sortable: true },
        { key: 'scanUser', label: 'Scan User', filterable: true, sortable: true },
      ],      
      filter: {
        'SAP DO' :  {
          field: 'sapDo',
          callback: (value) => {
            return ` ​${value}`
          }
        },
        'Status' : {
          field: 'status',
          callback: (value) => {
            return ` ​${value}`
          }
        },
        'Item Model' :'itemModel',
        'Scan Time' :'scanTime',
        'Scan User' : {
          field: 'scanUser',
          callback: (value) => {
            if(value==undefined){
              return 'unknown'
            }
            return ""+value.name
          }
        },
      },
      inventoryToDownload:[],
      search: '',
      soNumber: '',
      customerPo: '',
      currentPage: 1,
      perPage: 10,
      totalData: 1,

      minmin:'',
      startDate: '',
      endDate: '',
      maxDate: '',
      busyLoading: true,
      totalRows:0,
      promptDownload: false,
      downloadLoading: false,
      totalRowsDownload : 0,
      //download numbers
      downPage:0,
      dataDownload:0,
      inventoryToDownload:[],
      
    }
  },
  mounted() {
    
  },
  computed: {
    progressDownload () {
        let downloaded = this.inventoryToDownload.length
        let dataToDownload = this.totalRowsDownload
        return Math.ceil((downloaded/dataToDownload)*(100))
    },
    ...mapGetters({
      skipScan : 'report/skipScan'
    }),
    ...mapState({
      filterOrder: (state) => {
        if (state.filter.filterContainer['report-skip-scan-list'] !== undefined) {
          let orderFilter = state.filter.filterContainer['report-skip-scan-list'];
          return orderFilter;
        }

        return {};
      },
    }),
   reactiveStartDate: {
      get() {
        if(this.filterOrder.startDate === undefined){
          this.filterOrder.startDate = this.startDate
        }
      
        return this.filterOrder.startDate;
      },
      set() {
        this.updateFilterInventory({
          name: 'report-skip-scan-list',
          data: {
            startDate: this.filterOrder.startDate
          }
        });

      }
    },
    reactiveEndDate: {
      get() {
        if(this.filterOrder.endDate === undefined){
          this.filterOrder.endDate = this.endDate;
        }
        return this.filterOrder.endDate;
      },
      set() {
        this.updateFilterInventory({
          name: 'report-skip-scan-list',
          data: {
            endDate: this.filterOrder.endDate
          }
        });

      }
    },
  },
  methods: {
    ...mapActions({
      inventoryList : 'report/getSkipScan',
      getFilterInventory: 'filter/getFilter',
      updateFilterInventory: 'filter/updateFilter'
    }),
    async openDownloadModal(){
      this.downPage = 0
      this.dataDownload = 0
      this.inventoryToDownload = []
      this.promptDownload=true;
      this.downloadLoading=true;
      let page = 0
      var dataDownload=this.dataDownload
      while (dataDownload < this.totalRows) {
        console.info('total data now ',dataDownload,'all data ',this.totalRows)
        let dataProcess = []
        page++
        this.downPage = page  
         await this.inventoryList({
            startDate : this.startDate, 
            endDate : this.endDate,
            page: page, 
            entry: 100000,
            forDownload:true,
          }).then((res) => {
        // this.warrantyToDownload=data.data;
        dataProcess=res.data

        // Flatten the array of arrays
        const flattenedOrders = dataProcess.flat();
        this.totalRowsDownload = flattenedOrders.length
        // split into each item 
        this.inventoryToDownload.push(...flattenedOrders)
        dataDownload += flattenedOrders.length
        this.dataDownload = dataDownload
       
      });  
    }
      this.downloadLoading=false;
      

    },
    onPageChange(page) {
      this.currentPage=page;

      this.inventoryList({
        startDate : this.startDate, 
        endDate : this.endDate,
        page: this.currentPage, 
        entry: this.perPage,
       
      }).then((data) => this.processMetadata(data.metadata));
    },
    processMetadata(metadata) {
      let { totalData } = metadata;
      this.totalRows = totalData;
      this.busyLoading = false;
    },
    saveFilter(key, value) { //save updated filter
      let tempFilter = this.filterOrder; 

      if (value === null) {
        tempFilter[key] = undefined;
      } else {
        tempFilter[key] = value;
      }
      
      this.updateFilterInventory({ //save to store named is "filter"
        name: 'report-skip-scan-list',
        data: { ...tempFilter,entry: this.perPage,page:1 }
      });
    },
    fireFiltering(key, value) {
      this.saveFilter(key, value); //filter saved date
      
      let filter = this.filterOrder; 
      filter.startDate = this.startDate;
      filter.endDate = this.endDate;
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(this.endDate)
      minDate.setMonth(minDate.getMonth() - 1)
      minDate.setDate(minDate.getDate())
      this.minmin = minDate

      this.busyLoading = true;
      this.inventoryList({ ...filter,entry: this.perPage,page:1}).then((data) => {
        this.processMetadata(data.metadata)
      });
    },

    dates(date) {
      return dateFormat(date);
    },


  },
  created() {
    // Setup Store To Save Filtering Information
    this.getFilterInventory('report-skip-scan-list');

    let now = new Date();
    let yearAgo = new Date(now.getFullYear()-1, now.getMonth()+1, now.getDate())
    
    let monthAgo= new Date();
    monthAgo.setMonth(monthAgo.getMonth()-1);

    
    this.maxDate = now;
    this.startDate = monthAgo;
    this.endDate = now

    const minDate = new Date(this.endDate)
    minDate.setMonth(minDate.getMonth() - 1)
    minDate.setDate(minDate.getDate())

    this.minmin = this.endDate

    document.title = 'Skip Scan Report | RSP'

    this.inventoryList({
      startDate : this.startDate, 
      endDate : this.endDate,
      page: this.currentPage, 
      entry: this.perPage,
       
      }).then((data) => this.processMetadata(data.metadata));
  },
}
</script>
